import {
  RadarChart,
  Radar,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts"
import { round_with_spaces } from "../../../utils/functions"
import stats_font_sizes from "../../../configs/stats_font_sizes.json"
import theme_colors from "../../../configs/theme_colors.json"

export default function SpiderChart({ stats }) {
  const {
    community_health: {
      hyper_18_44,
      hyper_45_above,
      diab_18_44,
      diab_45_above,
    },
  } = stats

  const disease_data = [
    {
      disease: "Hypertension (18-44yrs)",
      value: hyper_18_44,
    },
    {
      disease: "Diabetes (>44yrs)",
      value: diab_45_above,
    },

    {
      disease: "Hypertension (>44yrs)",
      value: hyper_45_above,
    },
    {
      disease: "Diabetes (18-44yrs)",
      value: diab_18_44,
    },
  ]

  function CustomTooltipSpider({ payload, active }) {
    if (active) {
      return (
        <div
          className="custom-tooltip"
          style={{
            backgroundColor: "white",
            fontSize: stats_font_sizes.tooltip_font_size,
            padding: 4,
            border: "black",
            boxShadow: "4px 6px 3px rgba(0, 0, 0, 0.2)",
          }}
        >
          <p style={{ padding: 0, margin: 0 }}>{`${
            payload[0].payload.disease
          }: ${round_with_spaces(payload[0].payload.value)} people`}</p>
        </div>
      )
    }

    return null
  }

  const CustomAngleTickSpider = ({ payload, radius, cx, cy }) => {
    const angle = payload.coordinate
    const RADIAN = Math.PI / 180

    const newRadius = radius + 11

    const xPos = cx + (newRadius + 22) * Math.cos(-angle * RADIAN)
    const yPos = cy + newRadius * Math.sin(-angle * RADIAN)

    const lines = payload.value.split("_")

    return (
      <text x={xPos} y={yPos} textAnchor="middle" fontSize={13} fill="#666">
        {lines.map((line, index) => (
          <tspan key={index} x={xPos} dy={index === 0 ? 0 : 14}>
            {line}
          </tspan>
        ))}
      </text>
    )
  }

  return (
    <ResponsiveContainer width="100%" height="100%">
      <RadarChart outerRadius="70%" data={disease_data}>
        <PolarGrid />
        <PolarAngleAxis dataKey="disease" tick={CustomAngleTickSpider} />
        <PolarRadiusAxis tick={{ fontSize: 13, fill: "#5b5958" }} angle={45} />
        <Radar
          dataKey="value"
          stroke={theme_colors.ndoh_green}
          fill={theme_colors.ndoh_green}
          fillOpacity={0.6}
        />
        <Tooltip content={CustomTooltipSpider} />
      </RadarChart>
    </ResponsiveContainer>
  )
}
